import { FC, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import usePlacesAutocomplete, {
    getGeocode,
    getLatLng,
} from 'use-places-autocomplete';
import { updateFormTrip, updateFormTripMass } from "functions/redux/listing/action";
import FormItem from "components/Form/FormItem";
import Input from "shared/Input/Input";
import Loader from "react-loader-spinner";
import ncNanoId from "utils/ncNanoId";
import NcInputNumber from "components/NcInputNumber/NcInputNumber";
import Textarea from "shared/Textarea/Textarea";
// import GoogleMapReact from "google-map-react";
// import LocationMarker from "components/AnyReactComponent/LocationMarker";
import Geocode from "react-geocode";
import { getCountryByCode } from "functions/redux/country/action";
import { showAlert, showUnderConstructionAlert } from "functions/redux/general/action";
import { useTranslation } from "react-i18next";
import Switch from "react-switch";
// import { async } from "@firebase/util";
import { modalContent } from "containers/PageSignUp/PageSignUp";
// import Label from "components/Label/Label";

interface location {
    locationName: any,
    lat: any,
    lng: string,
    placeId: string,
    country: any
}

interface PrivateStepOneProps {
    form: any,
    country: any
}

const PrivateStepOne: FC<PrivateStepOneProps> = ({ form, country }) => {
    const {
        ready,
        value: place,
        suggestions: { status, data: suggestionsData },
        setValue: setPlace,
        clearSuggestions,
    } = usePlacesAutocomplete({
        defaultValue: "",
        requestOptions: country?.countryCode ? {
            componentRestrictions: {
                country: country.countryCode
            }
        } : undefined,
        debounce: 300,
    });
    const [originPlace, setOriginPlace] = useState("");
    const [placeLoading, setPlaceLoading] = useState(false);
    const [originPlaceLoading, setOriginPlaceLoading] = useState(false);
    const [lat, setLat] = useState(form?.meetingLat ?? 0);
    const [defLat, setDefLat] = useState(form?.meetingLat ?? 0);
    const [defLng, setDefLng] = useState(form?.meetingLng ?? 0);
    const [isChacked, setisChacked] = useState(false)
    const [mapCenter, setMapCenter] = useState({
        lat: form?.meetingLat ?? 0,
        lng: form?.meetingLng ?? 0
    }
    );
    const [lng, setLng] = useState(form?.meetingLng ?? 0);
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [locations, setLocations] = useState<any[]>(form?.productLocation ?? []);
    const [additionalSlot, setAdditionalSlot] = useState(false)

    useEffect(() => {
        if (form?.maxAddSlot > 0) {
            setisChacked(true)
        }
    }, [form])


    // useEffect(() => {
    //     if(form && form.maxGuest > 0){
    //         setisChacked(true);
    //     }
    // }, [])

    // const setMaxGuest = () => {
    //     setisChacked(!isChacked);
    //     dispatch(updateFormTrip('maxGuest', 0));

    // }

    const setAddSlot = () => {

        if (isChacked === true) {
            dispatch(updateFormTrip('maxAddSlot', 0));

        } else {
            dispatch(updateFormTrip('maxAddSlot', 1));

        }
        setisChacked(!isChacked);

    }

    const meetingAddressUpdate = (lat: number, lng: number,) => {
        Geocode.fromLatLng(lat, lng).then(
            async (response: any) => {
                const address = response.results[0].formatted_address;
                setOriginPlace(address);
                let localCountry: string | undefined;
                response.results.forEach((item: any, k: any) => {
                    if (item.types[0] === 'country') {
                        localCountry = item.address_components[0].short_name;
                    }
                });
                if (localCountry !== undefined && localCountry.toLowerCase() === country.countryCode.toLowerCase()) {
                    var res = await getCountryByCode(localCountry);
                    if (res.length > 0) {
                        dispatch(updateFormTripMass({
                            'country': res[0].id,
                            'meetingLat': lat,
                            'meetingLng': lng,
                            'meetingAddress': address
                        }));
                    } else {
                        dispatch(showUnderConstructionAlert(true, t('country_not_supported'), "Warning!"))
                    }
                } else {
                    dispatch(showUnderConstructionAlert(true, t('country_not_supported'), "Warning!"))
                }

            },
            (error: any) => {
                console.error(error);
            }
        );
    }

    const handleSelect = (address: string) => {
        setPlace(address, false);
        setPlaceLoading(true);
        clearSuggestions();
        getGeocode({ address })
            .then(async (results: any) => {

                var latLng = await getLatLng(results[0]);
                Geocode.fromLatLng(latLng.lat, latLng.lng).then(
                    async (params: any) => {
                        let country;

                        params.results.forEach((item: any, k: any) => {
                            if (item.types[0] === 'country') {
                                country = item.address_components[0].short_name;
                            }
                        });

                        if (country !== undefined) {
                            var res = await getCountryByCode(country);
                            if (res.length > 0 || res.id) {
                                var find = locations.find(o => o.placeId === results[0].place_id);
                                if (find === undefined) {
                                    locations.push({
                                        locationName: address,
                                        placeId: results[0].place_id,
                                        lat: latLng.lat,
                                        lng: latLng.lng,
                                        country: res?.id ? res.id : res[0].id
                                    });

                                    dispatch(updateFormTrip('productLocation', locations));
                                    form.locations = form.locations ?? [];
                                }
                            } else {
                                dispatch(showAlert(modalContent(t('country_not_supported')), "Warning!", true))
                            }

                            setPlace("", false);
                            setPlaceLoading(false);
                        } else {
                            dispatch(showAlert(modalContent(t('country_not_supported')), "Warning!", true))

                            setPlace("", false);
                            setPlaceLoading(false);
                        }

                    }
                )
            })
            .catch((error: any) => {
                console.error('Error', error);
                setPlaceLoading(false);
            });
    };
    const renderPlaces: FC<{ getInputProps: any, getSuggestionItemProps: any, suggestions: any }> = ({ getInputProps, getSuggestionItemProps, suggestions }) => (
        <div className="autocomplete-root">
            <FormItem label={t('recommendation_dest') + "*"}>
                <div className="relative">
                    <Input {...getInputProps()} className="mt-2" placeholder={t('find_place')} />
                    <div className="absolute inset-y-0 right-2 pr-3 flex items-center pointer-events-none">
                        {placeLoading ? <Loader
                            type="Circles"
                            color="#d24e29"
                            height={25}
                            width={25}
                        /> : <></>}
                    </div>
                </div>
            </FormItem>
            <div className="autocomplete-dropdown-container">
                {suggestions.map((suggestion: any) => (
                    <span style={{ cursor: 'pointer' }} key={ncNanoId()}{...getSuggestionItemProps(suggestion)} className="flex items-center justify-between py-3">
                        <span className="text-neutral-6000 dark:text-neutral-400 font-medium">
                            {suggestion.description}
                        </span>
                    </span>
                ))}
            </div>
        </div>
    )

    const handleOrigin = (address: any) => {
        setOriginPlace(address);
        setOriginPlaceLoading(true);
        getGeocode({ address })
            .then(async (results: any) => {

                var latLng = await getLatLng(results[0]);
                var find = locations.find(o => o.placeId === results[0].place_id);
                if (defLat === 0) {
                    setDefLat(latLng.lat);
                    setDefLng(latLng.lng);
                }

                setLat(latLng.lat);
                setLng(latLng.lng);

                setMapCenter({
                    lat: latLng.lat,
                    lng: latLng.lng
                })
                meetingAddressUpdate(latLng.lat, latLng.lng);
                setOriginPlaceLoading(false);
            })
            .catch((error: any) => console.error('Error', error));
    };

    const renderOrigin: FC<{ getInputProps: any, getSuggestionItemProps: any, suggestions: any }> = ({ getInputProps, getSuggestionItemProps, suggestions }) => (
        <div className="autocomplete-root">
            {/* <FormItem label={t('recommendation_dest')}> */}
            <div className="relative mb-2">
                <Input {...getInputProps()} className="mt-2" placeholder={t('find_place')} />
                <div className="absolute inset-y-0 right-2 pr-3 flex items-center pointer-events-none">
                    {originPlaceLoading ? <Loader
                        type="Circles"
                        color="#d24e29"
                        height={25}
                        width={25}
                    /> : <></>}
                </div>
            </div>
            {/* </FormItem> */}
            <div className="autocomplete-dropdown-container">
                {suggestions.map((suggestion: any) => (
                    <span style={{ cursor: 'pointer' }} key={ncNanoId()}{...getSuggestionItemProps(suggestion)} className="flex items-center justify-between py-3">
                        <span className="text-neutral-6000 dark:text-neutral-400 font-medium">
                            {suggestion.description}
                        </span>
                    </span>
                ))}
            </div>
        </div>
    )

    const findArrayIndex = (item: any) => {
        var nilai = 0;
        var innn: any = locations.findIndex((o, index) => {
            if (nilai > 0) {
                return false;
            }
            if ((o.locationName === item) && item !== undefined && o.locationName !== undefined) {
                nilai = index
            }
            // return false;
        });
        return nilai;

    }


    const removePlace = (placeId: string) => {

        const index = findArrayIndex(placeId);

        locations.splice(index, 1);
        dispatch(updateFormTrip('productLocation', locations));
        // var index: any = locations.find((o, index) => {
        //     if ((o.placeId === placeId) !== undefined) {
        //         return index
        //     } else {
        //         return false;
        //     }
        // });
        // if (index !== false) {
        //     locations.splice(index, 1);
        //     dispatch(updateFormTrip('productLocation', locations));
        // }

    }

    const renderSelectedPlaces = (location: location) => {
        return (<div key={ncNanoId()} className="flex items-center justify-between py-3">
            <span className="text-neutral-6000 dark:text-neutral-400 font-medium">
                {location.locationName}
            </span>
            <span style={{ cursor: 'pointer' }} onClick={() => removePlace(location.locationName)}>
                <i className="text-2xl text-neutral-400 las la-times-circle hover:text-neutral-900 dark:hover:text-neutral-100 cursor-pointer"></i>
            </span>
        </div>);
    }
    var restrict = {
        componentRestrictions: {
            country: country.countryCode
        }
    };
    return (<>
        <h2 className="text-2xl font-semibold">{t('basic_info')}</h2>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        <div className="space-y-8">
            <FormItem
                label={t('highlight') + "*"}
                desc={t('highlight_desc')}
            >
                <Input value={form?.highlight ?? ''} onChange={(e) => dispatch(updateFormTrip('highlight', e.target.value))} />
            </FormItem>
            <FormItem
                label={t('description') + "*"}
                desc={t('description_desc')}
            >
                <Textarea value={form?.description ?? ''} placeholder="..." rows={3} onChange={(e) => dispatch(updateFormTrip('description', e.target.value))} />
            </FormItem>
            <div className="space-y-7">
                {/* <div className="flex justify-between">
                    <span>Dapat menambahkan tamu</span>
                    <Switch onChange={setMaxGuest} checked={isChacked} />
                </div> */}
                <NcInputNumber className="mt-0"
                    desc="Jumlah maksimal tamu yang termasuk di dalam harga yang ditawarkan"
                    label={`Jumlah maksimal tamu per slot*`} defaultValue={form?.maxGuest ?? 4} onChange={(e) => dispatch(updateFormTrip('maxGuest', e))} />
            </div>
            <div className="space-y-2">
                {/* <div className="flex justify-between">
                    <span>Dapat menambahkan tamu</span>
                    <Switch onChange={setMaxGuest} checked={isChacked} />
                </div> */}
                <div className="flex justify-between">
                    <div className="flex flex-col">
                        <span className="font-medium text-neutral-800 dark:text-neutral-200">{t('enable_additonal_slot')}</span>
                        <span className="text-xs text-neutral-500 dark:text-neutral-400 font-normal">{t('add_additional_slot_desc')}</span>
                    </div>
                    <Switch onChange={setAddSlot} checked={isChacked} />
                </div>
                {isChacked && (
                    <NcInputNumber className="mt-0"
                        desc={`Jumlah maksimal slot yg dapat ditambahkan 1 slot untuk ${form?.maxGuest ?? 4} tamu`}
                        min={1}
                        label={`Jumlah maksimal slot tambahan*`} defaultValue={form?.maxAddSlot} onChange={(e) => dispatch(updateFormTrip('maxAddSlot', e))} />
                )}
            </div>
            <div className="autocomplete-root">
                <FormItem label={t('recommendation_dest') + "*"}>
                    <div className="relative">
                        <Input
                            value={place}
                            onChange={(e) => setPlace(e.target.value)}
                            disabled={!ready}
                            className="mt-2"
                            placeholder={t('find_place')}
                        />
                        <div className="absolute inset-y-0 right-2 pr-3 flex items-center pointer-events-none">
                            {placeLoading ? <Loader
                                type="Circles"
                                color="#d24e29"
                                height={25}
                                width={25}
                            /> : <></>}
                        </div>
                    </div>
                </FormItem>
                {status === "OK" && (
                    <div className="autocomplete-dropdown-container bg-white dark:bg-neutral-800 border border-neutral-200 dark:border-neutral-700 rounded-xl mt-1 shadow-lg overflow-hidden z-20 relative">
                        {suggestionsData.map((suggestion: any) => (
                            <div
                                key={suggestion.place_id}
                                onClick={() => handleSelect(suggestion.description)}
                                className="flex items-center justify-between py-3 px-4 hover:bg-neutral-100 dark:hover:bg-neutral-700 cursor-pointer transition-colors"
                            >
                                <span className="text-neutral-700 dark:text-neutral-300 font-medium text-sm">
                                    {suggestion.description}
                                </span>
                            </div>
                        ))}
                    </div>
                )}
            </div>
            {locations.length > 0 ?
                <div className="flow-root px-4">
                    <div className="-my-3 divide-y divide-neutral-100 dark:divide-neutral-800">
                        {locations.map((item) => renderSelectedPlaces(item))}
                    </div>
                </div> : <></>}


            {/* <FormItem
                label={t('origin_pt') + "*"}
                desc={t('origin_pt_desc')}
            >
                <div className="mt-4">
                    <PlacesAutocomplete
                        value={originPlace}
                        onSelect={handleOrigin}
                        onChange={(e: any) => setOriginPlace(e)}
                        searchOptions={restrict}

                    >
                        {renderOrigin}
                    </PlacesAutocomplete> */}


            {/* {locations.length > 0 ?
                        <div className="flow-root px-4">
                            <div className="-my-3 divide-y divide-neutral-100 dark:divide-neutral-800">
                                {locations.map((item) => renderSelectedPlaces(item))}
                            </div>
                        </div> : <></>} */}

            {/* {defLat !== 0 && defLng !== 0 ?
                        <div className="aspect-w-5 aspect-h-5 sm:aspect-h-3">
                            <div className="rounded-xl overflow-hidden">

                                <GoogleMapReact
                                    defaultZoom={15}
                                    center={mapCenter}
                                    defaultCenter={{
                                        lat: typeof defLat == "string" ? parseFloat(defLat) : defLat,
                                        lng: typeof defLng == "string" ? parseFloat(defLng) : defLng,
                                    }}
                                    onDrag={((map) => {
                                        setLat(map.center.lat());
                                        setLng(map.center.lng());
                                    })}

                                    onDragEnd={(map) => {
                                        setLat(map.center.lat());
                                        setLng(map.center.lng());
                                        meetingAddressUpdate(map.center.lat(), map.center.lng());
                                    }}

                                >
                                    <LocationMarker lat={lat !== 0 ? lat : defLat} lng={lng !== 0 ? lng : defLng} />
                                </GoogleMapReact>

                            </div>
                        </div> : <div className="flex flex-col lg:flex-row lg:items-center w-full flex-shrink-0 relative">
                            <Loader
                                type="Circles"
                                color="#d24e29"
                                height={25}
                                width={25}
                            />
                            <span className="ml-4 block mt-1 text-sm text-neutral-500 dark:text-neutral-400">
                                {t('add_some_dest')}
                            </span>
                        </div>
                    }
                </div>
            </FormItem> */}
        </div>
    </>);
}

export default PrivateStepOne;